export const POLYGON_AI_TOOL_INSTRUCTION = {
  noOrthomosaic:
    'To use AI-assisted digitisation, load an orthomosaic in the workspace.',
  enableMode:
    'Enable AI Mode to get automatic polygon suggestions from the orthomosaic.',
  refineMode: 'Click on the map to refine polygons.',
  addPolygons: 'Click on a highlighted area to add polygons.',
  keepClicking:
    'Add a few more clicks until the polygon you want is digitised.',
} as const;
